var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"font-medium"},[_vm._v(" "+_vm._s(_vm.suprafataTotala)+" ")]),_vm._v(" m² ")])
}
var staticRenderFns = []

export { render, staticRenderFns }